export default "__VITE_ASSET__Dy2u2rnH__"